import React, { ReactNode } from 'react';

import { paths } from 'client/shared/Paths';
import {
  MarketingAnchor,
  MarketingBoldLink,
} from 'components/MarketingPagesShared/styles';
import { MarketingButton } from 'components/MarketingPagesShared/MarketingButton';
import { HomeSection } from '../../../styles';
import {
  HomeSignupBackground,
  HomeSignupButton,
  HomeSignupContainer,
  HomeSignupFooter,
  HomeSignupHeader,
  HomeSignupText,
} from './styles';

export function HomeSignup({
  showSwitchLink = true,
  onClickGetStarted,
  onClickSwitch,
  children,
}: {
  showSwitchLink?: boolean;
  onClickGetStarted?: () => void;
  onClickSwitch?: () => void;
  children?: ReactNode;
}) {
  return (
    <HomeSignupBackground>
      <HomeSection>
        <HomeSignupContainer>
          <HomeSignupHeader>
            For everyone, everywhere, for free
          </HomeSignupHeader>
          <HomeSignupText>
            We believe everyone’s stories can and should be heard, so we’re
            giving creators around the world—from first-time podcasters to
            pros—a powerful platform to{' '}
            <MarketingAnchor
              href={paths.blog.freePodcastingWithAnchor}
              target="_blank"
              rel="noopener noreferrer"
            >
              share their voices
            </MarketingAnchor>
            .
          </HomeSignupText>
          <HomeSignupButton>
            <MarketingButton
              kind="link"
              href={paths.anchor.signup}
              onClick={onClickGetStarted}
            >
              Get started
            </MarketingButton>
          </HomeSignupButton>
          {showSwitchLink && (
            <HomeSignupFooter>
              Already have a podcast?{' '}
              <MarketingBoldLink
                to={paths.anchor.switch}
                onClick={onClickSwitch}
              >
                Switch to Anchor
              </MarketingBoldLink>
            </HomeSignupFooter>
          )}
        </HomeSignupContainer>
      </HomeSection>
      {children}
    </HomeSignupBackground>
  );
}
